import React, { useCallback, useEffect, useMemo, useState } from "react";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { useSelector } from "react-redux";
import { getMatches } from "../helpers/getMatches";
import { useTranslation } from "react-i18next";

const filterArray = (filter, matchDays, matchesState) => {
    if (!filter) return matchDays;

    return matchDays.filter((matchDay) => {
        const matches = getMatches(matchDay, matchesState);
        return filter.filterFunction(matches);
    });
};

export default function FilterBar({ setFilteredDays }) {
    const matchDays =
        useSelector((state) => state.leagueReducer.data?.matchDays) ?? [];
    const matchesState =
        useSelector((state) => state.matchesReducer.data) ?? [];
    const teamOptions = useSelector((state) => state.teamsReducer.data) ?? [];
    const [filter, setFilter] = useState(null);
    const [nestedValue, setNestedValue] = useState(null);
    const { t } = useTranslation();

    const filterOptions = useMemo(
        () => [
            {
                value: "1",
                label: t("gamedays.filters.with_location"),
                filterFunction: (matches) =>
                    matches?.find((match) => !match.location) === undefined,
                nestedFilter: false,
            },
            {
                value: "2",
                label: t("gamedays.filters.without_location"),
                filterFunction: (matches) =>
                    matches?.find((match) => !match.location) !== undefined,
                nestedFilter: false,
            },
            // {
            //       value: '3',
            //       label: 'Team',
            //       filterFunction: (item) => item,
            //       nestedFilter: true,
            // }
        ],
        [t]
    );

    useEffect(() => {
        if (matchDays?.length === 0) return;
        if (!filter?.nestedFilter) {
            setFilteredDays(filterArray(filter, matchDays, matchesState));
        } else {
        }
    }, [filter, nestedValue, matchDays]);

    const handleSelectChange = useCallback((event) => {
        const value = event?.target?.value;
        setFilter(filterOptions.find((option) => option.value === value));
    }, []);

    // Unfinished functionality. There were an idea to have complex filters,
    // that on select would trigger another components to appear, such as team select, date picker, etc.
    const renderNested = () => {
        switch (filter?.value) {
            case "3":
                return (
                    <FormControl sx={{ m: 1, width: "12rem" }}>
                        <InputLabel id="demo-multiple-chip-label">
                            Teams Filter
                        </InputLabel>
                        <Select
                            placeholder="Chip"
                            value={nestedValue ? nestedValue.value : ""}
                            onChange={(e) => setNestedValue(e.target.value)}
                            input={<OutlinedInput />}
                        >
                            {teamOptions.map((team) => (
                                <MenuItem key={team.id} value={team.id}>
                                    {team.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                );
            default:
                return null;
        }
    };

    return (
        <div className="filter-wrap">
            <FormControl sx={{ m: 1, width: "14rem" }}>
                <InputLabel id="demo-multiple-chip-label">
                    {t("gamedays.filters.input_label")}
                </InputLabel>
                <Select
                    placeholder="Chip"
                    value={filter ? filter.value : ""}
                    onChange={handleSelectChange}
                    input={<OutlinedInput label="Chip" />}
                >
                    {filterOptions.map((filter) => (
                        <MenuItem key={filter.value} value={filter.value}>
                            {filter.label} d
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}
